import { getAll } from '@vercel/edge-config'

import type { EdgeConfig } from './schema.ts'

let cached: EdgeConfig | null = null
let cacheTimestamp = 0
let pending: Promise<EdgeConfig> | null = null

const CACHE_TTL_MS = 60_000

export const resetEdgeConfigCache = () => {
  cached = null
  cacheTimestamp = 0
  pending = null
}

export const edgeConfig = async (): Promise<EdgeConfig> => {
  const expired = cached !== null && Date.now() - cacheTimestamp > CACHE_TTL_MS

  if (cached !== null && !expired) {
    return cached
  }

  if (expired) {
    pending = null
  }

  if (pending === null) {
    pending = getAll<EdgeConfig>()
  }

  cached = await pending
  cacheTimestamp = Date.now()
  return cached
}
